export default __webpack_public_path__ + "static/media/bodycard2.18229522.png";